import {useState} from 'react';
import {SBack, SListTabs} from 'shj-components';
import InsureAccountList from './insureAccount';
import InsureRecordList from './insureRecord';
import InsuranceSettingList from './insurancesetting';
import { useRequest } from 'ahooks';
import { httpCompanyList, searchCompanyList } from '@/services/homeService';

export default function () {
    const [hideExtra, setHideExtra] = useState(false);
    //不包含无效的无权限列表
    let {data: companyList = []} = useRequest(httpCompanyList);
     //包含无效的无权限列表
    let {data: allCompanyList = []} = useRequest(httpCompanyList, {
        defaultParams: [{status: ''}],
    });
    //包含无效的有权限列表
    let {data: authAllCompanyList = []} = useRequest(searchCompanyList, {
        defaultParams: [{status: ''}],
    });
    const items = [
        {
            key: '1',
            label: '保险账户',
            // auth: 'insureAccount',
            children: <InsureAccountList allCompanyList={authAllCompanyList}/>,
        },
        {
            key: '2',
            label: '保险流水',
            // auth: 'insureRecord',
            children: <InsureRecordList/>,
        },
        {
            key: '4',
            label: '保险配置',
            // auth: 'insurancesetting',
            children: <InsuranceSettingList companyList={companyList} allCompanyList={allCompanyList}/>,
        }
    ];
    const changeTabs =(values: string)=>{
        if(values === '2'){
            setHideExtra(true)
        }else{
            setHideExtra(false)
        }
    }

    return (
        <div className="low-code-demo">
            <SBack title="保险管理"></SBack>
            <SListTabs items={items} onChange={changeTabs} hideExtra={hideExtra} auth={false} />
        </div>
    );
}
